import {Component, OnInit} from '@angular/core';
import {LanguageService} from '../../../services/languages/language.service';
import {Router} from '@angular/router';
import {NavBarService} from '../../../services/nav-bar/nav-bar.service';
import {TranslatableString} from '../../../models/TranslatableString';

@Component({
  selector: 'app-about-region-and-country',
  templateUrl: './about-region-and-country.component.html',
  styleUrls: ['./about-region-and-country.component.scss']
})
export class AboutRegionAndCountryComponent implements OnInit {
  selectedRegion: TranslatableString;
  lang: string;

  constructor(public ls: LanguageService, public nav: NavBarService, private router: Router, private languageService: LanguageService) {
    languageService.currentLanguageKey.subscribe((val) => {
      this.lang = val;
    });
  }

  ngOnInit() {
    setTimeout(() => {
      this.nav.deselectAll();
      this.nav.regionAndCountrySelected = true;
      this.nav.helpSelected = true;
      if (this.router.url.indexOf('varna') !== -1) {
        this.nav.varnaSelected = true;
      } else if (this.router.url.indexOf('bulgaria') !== -1) {
        this.nav.bulgariaSelected = true;
      } else if (this.router.url.indexOf('regions') !== -1) {
        this.nav.regionsSelected = true;
      }
    }, 0);
  }

  clickBulgaria() {
    this.nav.deselectAll();
    this.nav.regionAndCountrySelected = true;
    this.nav.helpSelected = true;
    this.nav.bulgariaSelected = true;
    this.nav.bulgariaClicked();
  }

  clickVarna() {
    this.nav.deselectAll();
    this.nav.regionAndCountrySelected = true;
    this.nav.helpSelected = true;
    this.nav.varnaSelected = true;
    this.nav.varnaClicked();
  }

  clickRegions() {
    this.nav.deselectAll();
    this.nav.regionAndCountrySelected = true;
    this.nav.helpSelected = true;
    this.nav.regionsSelected = true;
    this.nav.regionsClicked();
  }

  getSelectedRegionText() {
    if (this.lang === 'en') {
      return this.selectedRegion.valueEn;
    } else {
      return this.selectedRegion.valueBg;
    }
  }
}
